// `<DirtyAsterisk />` — visible "*" rendered next to the screen title
// when the persistence layer has unwritten changes pending the
// debounced write (Banks Ask 5 → option a). Mirrors VS Code / Sublime
// dirty-document marker UX.
//
// Subscribes to the persistence layer's `pendingWrites` signal (P-035
// extension to D-083). Re-renders only on 0 ↔ 1 transitions thanks to
// the factory's identity-skip semantics.

import { usePendingWrites } from '../../store/persistence'

export function DirtyAsterisk() {
  const pending = usePendingWrites()
  if (pending === 0) return null
  return (
    <span
      class="text-base font-semibold text-amber-700"
      aria-label="Unsaved changes"
      title="Unsaved changes"
    >
      *
    </span>
  )
}
